import { Shimmer } from "../styles"

export const PageLoaderList = () => {
    return (
        <Shimmer style={{marginTop: '24px', height: '220px'}}></Shimmer>
    )
}